module.exports = __webpack_public_path__ + "fonts/unicredit-bolditalic.ae3a255a.eot";